import api from "../api/api";

export const HeroSectionServices = {
  async list() {
    const res = await api.get("/get-hero-section");
    return res.data;
  },
};
